import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TranslationFeedbackCreateGQL,
  TranslationFeedbackDeleteGQL,
  TranslationFeedbackTypeEnum,
  TranslationFeedbackUpdateGQL,
} from '../../../graphql/service/graphql-auto-main-service';
import { MutationHandlingServiceV2 } from '@akebono/core';

@Injectable()
export class LotTranslationsFeedbackService {
  constructor(
    private readonly mhs: MutationHandlingServiceV2,
    private readonly translationFeedbackCreateGQL: TranslationFeedbackCreateGQL,
    private readonly translationFeedbackUpdateGQL: TranslationFeedbackUpdateGQL,
    private readonly translationFeedbackDeleteGQL: TranslationFeedbackDeleteGQL,
  ) {}

  createTranslationFeedback(
    translationId: string,
    message: string,
    type: TranslationFeedbackTypeEnum,
  ): Observable<boolean> {
    return this.mhs.mutate(
      this.translationFeedbackCreateGQL,
      { input: { translationId, feedbackType: type, message } },
      {
        refetch: true,
        successTranslationKey: 'USER_REQUESTS.THANKS_FOR_FEEDBACK',
        failureTranslationKey: 'USER_REQUESTS.FEEDBACK_ERROR',
      },
    ).loading;
  }

  updateTranslationFeedback(
    id: string,
    message: string,
    type: TranslationFeedbackTypeEnum,
  ): Observable<boolean> {
    return this.mhs.mutate(
      this.translationFeedbackUpdateGQL,
      { input: { id, feedbackType: type, message } },
      {
        refetch: true,
        successTranslationKey: 'USER_REQUESTS.THANKS_FOR_FEEDBACK',
        failureTranslationKey: 'USER_REQUESTS.FEEDBACK_ERROR',
      },
    ).loading;
  }

  deleteTranslationFeedback(id: string): Observable<boolean> {
    return this.mhs.mutate(
      this.translationFeedbackDeleteGQL,
      { input: { id } },
      {
        refetch: true,
        renderSuccess: false,
      },
    ).loading;
  }
}
